import { uiText } from '../../i18n/uiText';
import React from 'react';

// Causes belong to a finding, actions reference stable keys, not array indexes.
export default function CauseAnalysisEditor({ issues, value = [], onChange, readOnly }) {
  const update = (issueId, transform) => {
    const row = value.find(item => item.issue_id === issueId) || { issue_id: issueId, causes: [], correction: '', containment: '' };
    onChange([...value.filter(item => item.issue_id !== issueId), transform(row)]);
  };
  return <section className="card" aria-label={uiText("Анализ причин несоответствий")}>
    <div className="card-header"><div className="card-title">{uiText("Причины несоответствий")}</div></div>
    <div className="card-body" style={{ display: 'grid', gap: 20 }}>
      <p className="text-muted">{uiText("Черновик можно сохранить незаполненным. Перед согласованием у каждого Major/Minor должна быть причина, а у каждой причины — корректирующее действие.")}</p>
      {issues.filter(issue => ['major', 'minor'].includes(issue.priority)).map(issue => {
        const row = value.find(item => item.issue_id === issue.id) || { causes: [] };
        return <fieldset key={issue.id} style={{ border: '1px solid var(--border-color, #475569)', borderRadius: 12, padding: 16, minWidth: 0 }}>
          <legend style={{ padding: '0 8px', fontWeight: 600 }}>{issue.title}</legend>
          <div style={{ display: 'grid', gap: 12 }}>
            {(row.causes || []).map((cause, index) => <div key={cause.key} className="form-group">
              <label className="form-label" htmlFor={`cause-${cause.key}`}>{uiText("Причина ")}{index + 1}</label>
              <textarea id={`cause-${cause.key}`} className="ap-control" rows={2} value={cause.text} readOnly={readOnly}
                onChange={event => update(issue.id, item => ({ ...item, causes: item.causes.map(c => c.key === cause.key ? { ...c, text: event.target.value } : c) }))} />
              {!readOnly && <button type="button" className="btn btn-outline btn-sm" style={{ marginTop: 8 }}
                onClick={() => update(issue.id, item => ({ ...item, causes: item.causes.filter(c => c.key !== cause.key) }))}>{uiText("Удалить причину")}</button>}
            </div>)}
            {!readOnly && <div><button type="button" className="btn btn-outline" onClick={() => update(issue.id, item => ({ ...item,
              causes: [...item.causes, { key: window.crypto.randomUUID(), text: '' }] }))}>{uiText("Добавить причину")}</button></div>}
            <details><summary>{uiText("Коррекция и сдерживание — необязательно")}</summary>
              <div style={{ display: 'grid', gap: 12, paddingTop: 12 }}>
                {[['correction', uiText("Коррекция — как исправили обнаруженное")], ['containment', uiText("Сдерживание — как ограничили последствия")]].map(([key, label]) =>
                  <label className="form-group" key={key}><span className="form-label">{label}</span>
                    <textarea className="ap-control" rows={2} value={row[key] || ''} readOnly={readOnly}
                      onChange={event => update(issue.id, item => ({ ...item, [key]: event.target.value }))} />
                  </label>)}
              </div>
            </details>
          </div>
        </fieldset>;
      })}
    </div>
  </section>;
}
